import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "types/redux";

export const getCoachmarks = createSelector(
  (state: RootState) => state.entities.coachmarks.byId,
  (coachmarksById) => Object.values(coachmarksById).filter((item) => item !== undefined),
);
